import React, { Component } from 'react';

import { getBtnClass } from '@triage-help/helpers';

class ConfirmCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      target: null,
    };
  }

  onTargetChange(e) {
    this.setState({
      target: e.currentTarget.value,
    });
  }

  render() {
    const { step, goToPrev } = this.props;
    const prevLink = step.link.find(l => l.type == 'prev');

    return (
      <div className="fv-triage-card">
        <div className="row">
          <div
            className="col-sm-12 col-md-7 fv-triage-card__content"
            dangerouslySetInnerHTML={{ __html: step.content }}
          />
          <div className="col-sm-12 col-md-5 fv-triage-card__side">
            {step.confirmation
              .filter(l => l.type == 'checkbox')
              .map((link, i) => (
                <div
                  className="fv-triage-card__cta fv-triage-card__cta--checkbox"
                  key={i}
                >
                  <input
                    type="radio"
                    id={link.target}
                    name="target"
                    value={link.target}
                    checked={this.state.target === link.target}
                    onChange={this.onTargetChange.bind(this)}
                  />
                  <label htmlFor={link.target}>{link.text}</label>
                  <label
                    htmlFor={link.target}
                    className="fv-triage-card__cta__label"
                  />
                </div>
              ))}
          </div>
          <div className="col-md-12 fv-triage-card__links">
            {prevLink && (
              <button
                className={getBtnClass(prevLink.type)}
                onClick={() => goToPrev()}
              >
                {prevLink.text}
              </button>
            )}
            <div className="fv-triage-card__links__next">
              {step.link
                .filter(l => l.type == 'next')
                .map((link, i) => {
                  return (
                    <button
                      className={getBtnClass(link.type, !!this.state.target)}
                      key={i}
                      onClick={() => this.props.goToStep(this.state.target)}
                    >
                      {link.text}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmCheckbox;
